import React from 'react';
import { ThumbnailProps } from '@printdeal/ui-library';
import splitOnFirst from 'split-on-first';

import LineItem from '../../../../types/cart/LineItem';
import ArtworkThumbnail from '../ArtworkThumbnail';
import {
  dispatchAccountEvent,
  DispatchCategoriesAccount,
} from '../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface OrderLineItemArtworkProps {
  lineItem: LineItem;
  thumbSize?: ThumbnailProps['size'];
  thumbClasses?: string;
  dispatchEventCategory?: DispatchCategoriesAccount;
}

const OrderLineItemArtwork = ({
  lineItem,
  thumbSize = 'md',
  thumbClasses = 'lg:pd-rounded-r-0',
  dispatchEventCategory = 'order_detail_interaction',
}: OrderLineItemArtworkProps) => {
  const lineItemCustomFields = lineItem?.custom?.fields || {
    lineItemNumber: undefined,
    localizedProductName: undefined,
    mcpDocumentsSource: undefined,
    merchandisingProductName: undefined,
    productKey: undefined,
    userSelection: undefined,
    variableAttributes: undefined,
    revisedPromisedArrivalDateV2: undefined,
    revisedPromisedArrivalDate: undefined,
    promisedArrivalDate: undefined,
  };

  return (
    <ArtworkThumbnail
      lineItem={lineItem}
      documentReference={(lineItemCustomFields.mcpDocumentsSource
        && Array.isArray(lineItemCustomFields.mcpDocumentsSource)
        && lineItemCustomFields.mcpDocumentsSource[0]
        && splitOnFirst(lineItemCustomFields.mcpDocumentsSource[0] as string, ':')[1]) || undefined}
      userSelection={lineItemCustomFields.userSelection}
      isDeliveredFileValid
      size={thumbSize}
      className={thumbClasses}
      clickedCallback={() => dispatchAccountEvent(dispatchEventCategory, 'open_preview_modal')}
    />
  );
};

export default OrderLineItemArtwork;
